module.exports = __webpack_public_path__ + "img/icon2.79d9fd0c.png";